import BeamElement from "./element.js";

export default class Beam extends BeamElement{
    constructor(type, length) {
        super(type);
        this.length = length;
    }
} 